<template>
  <div class="HomeButtons">
    <!-- <v-btn-toggle dense borderless v-model="homePage"> -->
    <!-- v-model="homePage"
      :active-class="
          $vuetify.theme.dark ? 'switchq switchqSub--text' : 'switchq--text'
          "
        value="mainDash" -->
    <v-btn
      @click="changeRoute('/')"
      small
      text
      elevation="0"
      :color="!$vuetify.theme.dark ? 'switchq' : 'switchqSub lighten-3'"
    >
      <v-icon>{{ "mdi-view-dashboard" }} </v-icon></v-btn
    >
    <!-- v-model="homePage"
      :active-class="
        $vuetify.theme.dark ? 'switchq switchqSub--text' : 'switchq--text'
        "
      value="devices" -->
    <v-btn
      @click="changeRoute('/devices')"
      small
      text
      elevation="0"
      :color="!$vuetify.theme.dark ? 'switchq' : 'switchqSub lighten-3'"
    >
      {{ $t("links.all-devices") }}</v-btn
    >
    <!-- v-model="homePage"
      :active-class="
        $vuetify.theme.dark ? 'switchq switchqSub--text' : 'switchq--text'
      " -->
    <!-- value="groups" -->
    <v-btn
      @click="changeRoute('/groups')"
      small
      text
      elevation="0"
      :color="!$vuetify.theme.dark ? 'switchq' : 'switchqSub lighten-3'"
      >{{ $t("links.groups") }}</v-btn
    >
    <!-- </v-btn-toggle> -->
  </div>
</template>
<script>
export default {
  name: "HomeButtons",
  data() {
    return {
      //
    };
  },
  watch: {
    homePage: {
      handler() {
        console.log(this.homePage);
      },
      deep: true,
    },
  },
  computed: {
    hasGroups() {
      return this.$store.getters["groups/hasGroups"];
    },
    homePage: {
      get() {
        let home = localStorage.getItem("homePage");
        if (home == "mainDash") {
          return null;
        } else {
          return home;
        }
        // return localStorage.getItem("homePage");
      },
      set(home) {
        if (home) {
          if (home == "groups" && !this.hasGroups) {
            this.$router.push("/groups/edit");
          } else {
            let path = null;
            if (home == "mainDash") {
              path = "/";
              this.$router.push(path);
              localStorage.setItem("homePage", home);
            } else {
              path = "/" + home;
              this.$router.push(path);
              localStorage.setItem("homePage", home);
            }
          }
          localStorage.setItem("homePage", home);
          // console.log("home from storage", localStorage.getItem("homePage"));
        }
      },
    },
  },
  methods: {
    changeRoute(path) {
      // console.log(this.$router);
      if (this.$router.history.current.path != path) {
        this.$router.push(path);
      }
    },
  },
};
</script>
<style scoped lang="scss">
// .v-btn-toggle--group {
//   border: unset;
// }
.HomeButtons {
  // display: flex;
  // justify-content: space-between;
  width: 100vw;
  display: flex;
  justify-content: space-between;
  margin-inline-end: 18vw;
  .v-btn {
    border-radius: 4px;
    padding: 2px 6px;
    // border-right: 1px solid darkgray;
    // &:last-of-type {
    // border-right: 0;
    // border-radius: 4px;
    // border-top-left-radius: 0;
    // border-bottom-right-radius: 0;
    // }
    // &:first-of-type {
    // border-left: 0;
    // border-top-right-radius: 0;
    // border-bottom-right-radius: 0;
    // }
    // &
  }
}
</style>
